( function ($) {
	/**
	 * Inject + edit member information in popup modal
	 */
	$( 'button.edit' ).on( 'click', function(e) {
		e.preventDefault();

		/**
		 * Gather the various user information 
		 */
		let cPKey = $( '#cPKey' ).text();
		let firstName = $( '#firstName' ).text();
		let lastName = $( '#lastName' ).text();
		let email = $( '#accountEmail' ).text();
		let phone = $( '#accountPhone' ).text();
		let access = $( '#access' ).text();
		let id = $( '#id' ).text();
		let userName = $( '#userName' ).text();
		let companyId = $( '#buyingCompanyId' ).text();
		let customerId = $( '#customerId' ).text();
		let accountStatus = $( '#accountStatus' ).text();
		let region = $( '#accountRegion' ).text(); // For region text
		let regionVal = $( '#accountRegion' ).data( 'value' ); // For region id
		let orderNotice = $( '#orderNotice' ).length > 0 ? true : false; 
		let accpayNotice = $( '#accpayNotice' ).length > 0 ? true : false;
		let generalNotice = $( '#generalNotice' ).length > 0 ? true : false;
		let dailyHTML = $( '#dailyLimit' ).text(); 
		let dailyLimit = dailyHTML.replace( /\D/g, '' );
		let weeklyHTML = $( '#weeklyLimit' ).text(); 
		let weeklyLimit = weeklyHTML.replace( /\D/g, '' );
		let orderHTML = $( '#orderLimit' ).text(); 
		let orderLimit = orderHTML.replace( /\D/g, '' );

		

		/**
		 * Insert them into the form, making sure to add the
		 * values where the $_POST request are reading them
		 */
		$( '#fname' ).val( firstName );
		$( '#lname' ).val( lastName );
		$( '#email' ).val( email );
		$( '#visible_email' ).val( email );
		$( '#phonenum' ).val( phone );

		if( access ) {
			$( '#pm_btn_role' ).text( access ).css( 'color', '#000' ); // apply value to button label
		}

		if( region ) {
			$( '#pm_btn_region' ).text( region ).css( 'color', '#000' ); // apply value to button label
		}

		$( '#pm_role' ).val( access );	// apply value to json data
		$( '#pm_region' ).val( region );	// apply text value to json data
		$( '#pm_region_id' ).val( regionVal );	// apply id value to json data
		$( '#orderRelatededitUser' ).prop( "checked", orderNotice );
		$( '#accPayeditUser' ).prop( "checked", accpayNotice );
		$( '#genNoticeeditUser' ).prop( "checked", generalNotice );
		$( '#dlimit' ).val( dailyLimit );
		$( '#wlimit' ).val( weeklyLimit );
		$( '#olimit' ).val( orderLimit );
		$( '#pm_as' ).val( accountStatus );
		$( '#pm_cid' ).val( cPKey );
		$( '#bl_id' ).val( id );
		$( '#bl_username' ).val( userName );
		$( '#bl_companyid' ).val( companyId );
		$( '#bl_customerId' ).val( customerId );

		// calls from chips.js
		notificationChips();
	} );

	$( '.notification-checkbox' ).on( 'change', function() {
		notificationChips();
	} );
} )( jQuery );
